import Enumerable from "braindamage/model/enumerable";
import Attributable from "braindamage/model/attributable";
import Nameable from "braindamage/model/nameable";
import Validateable from "braindamage/model/validateable";

class Model {
  static models = {};

  constructor(attributes = {}) {
    Object.values(this.constructor.attributes()).forEach((attribute) => {
      if(attributes.hasOwnProperty(attribute.camelName)) {
        this[attribute.camelName] = attributes[attribute.camelName];
      } else if(attributes.hasOwnProperty(attribute.apiName)) {
        this[attribute.camelName] = attributes[attribute.apiName];
      } else if(attributes.hasOwnProperty(attribute.underscoreName)) {
        this[attribute.underscoreName] = attributes[attribute.underscoreName];
      } else {
        this[attribute.name] = attribute.default;
      }
    });
  }

  static define() {
    Model.models[this.schema.modelName] = this;
    this.defineAttributes();
    this.defineEnums();
    this.defineNames();
    this.defineValidators();

    return this;
  }

  serialize() {
    const raw = {};

    Object.values(this.constructor.attributes()).forEach((attribute) => {
      raw[attribute.name] = this[attribute.name];
    });

    return raw;
  }

  underscoreSerialize({ selected = null }) {
    const raw = {};

    Object.values(this.constructor.attributes()).forEach((attribute) => {
      if(selected == null || selected.indexOf(attribute.underscoreName) != -1) {
        raw[attribute.underscoreName] = this[attribute.name];
      }
    });

    return raw;
  }

  get isPersisted() {
    return !this.isNewRecord;
  }

  get isNewRecord() {
    return isNaN(this.id);
  }

  clone() {
    return new this.constructor(this.serialize());
  }

  getAttribute(name) {
    return this.constructor.getAttribute(name)
  }
}

Object.assign(Model, Attributable)
Object.assign(Model, Enumerable)
Object.assign(Model, Nameable)
Object.assign(Model, Validateable)

export default Model;
